import React from "react";

export const MedicationDetailPharmacyDialog = ({dataObj}) => {
  return (
    //<div className="model-l-scroll">
      <div className="px-4 space-y-1">
        <div className="mt-2 mb-2 flex flex-col">
            <div className="inline-block">
                    <>
                      <div className="block">
                        <div className="black-c-600">
                        {dataObj?.name && ( 
                          <p className="text-sm black-c-600 font-light"> <strong> Name: </strong> {dataObj?.name} </p>)}
                          {(dataObj?.address1 || dataObj?.address2) && ( 
                            <p className="text-sm black-c-600 font-light"> <strong> Address: </strong><span>{dataObj?.address1}{" "} {dataObj?.address2}{' '}</span>  
                            <span>{dataObj?.city+","}{' '} {dataObj?.state} {' '} {dataObj?.zip_code}</span>
                            </p>
                          )}
                         {dataObj?.primary_phone && ( <p className="text-sm black-c-600 font-light"> <strong> Phone: </strong> {dataObj?.primary_phone} </p>)}
                         {dataObj?.primary_fax && ( <p className="text-sm black-c-600 font-light"> <strong> Fax: </strong> {dataObj?.primary_fax} </p>)}
                        {dataObj?.pharmacy_type && (  <p className="text-sm black-c-600 font-light"> <strong> Type: </strong> {dataObj?.pharmacy_type} </p>)}
                        </div>
                      </div>
                    </>
                  </div>
              </div>
            </div>
          //</div>
  );
};
